/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Form/view.blocks to change it.
import CaptchaInfo from 'DesignSystem/CaptchaInfo/index'
import Connection from './Connection/index'
import Data from './Data/index'
import Progress from './Progress/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Form({
  children,
  viewPath = "/App/Form"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="Form.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-9F4O': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<Progress
  viewPath={`${viewPath}/Progress`}
/>
<Data
  viewPath={`${viewPath}/Data`}
/>
<Connection
  viewPath={`${viewPath}/Connection`}
/>
<CaptchaInfo
  viewPath={`${viewPath}/CaptchaInfo`}
/>
</div>
{children}
</React.Fragment>)
}